import { useMemo } from 'react';
import { Country } from 'models/Country';
import { useCountrySelectListQuery } from 'api';

export const useCountryMapping = () => {
  const { data: countryList = [] } = useCountrySelectListQuery();

  const countryMapping = useMemo(() => {
    const mapping: Record<string, Country> = {};
    countryList.forEach((i: Country) => {
      mapping[i.id] = i;
    });
    return mapping;
  }, [countryList]);

  return {
    countryMapping,
  };
};
